<medrecord-tool-toast></medrecord-tool-toast>
<medrecord-tool-spinner></medrecord-tool-spinner>
<router-outlet></router-outlet>